export default function Hero() {
  const whatsappUrl =
    "https://wa.me/56920910798?text=Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n.";

  const goToFeatures = () => {
    const el = document.getElementById("features");
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* BG */}
      <div className="absolute inset-0">
        <img
          src="/img/hero1.jpeg"
          alt="Clínica dermatológica"
          className="
            h-full w-full object-cover scale-110
            object-[72%_center]
            sm:object-[68%_center]
            md:object-[68%_center]
            lg:object-[65%_center]
            xl:object-[center]
          "
        />
      </div>

      {/* overlays */}
      <div className="absolute inset-0 bg-black/25" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30" />

      {/* content */}
      <div className="relative z-10 flex h-full items-center justify-center px-6">
        <div className="max-w-3xl text-center text-white">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/20 px-4 py-1 text-xs backdrop-blur">
            Estética | Belleza | Cuidado de la piel | Salud
          </span>

          <h1 className="mt-6 text-4xl font-semibold leading-tight tracking-tight md:text-6xl">
            BEL SKIN NURSE <br />
            <span className="text-brand-1">Ciencia que realza tu belleza</span>
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-base text-white/90 md:text-lg">
            Bienvenid@ a tu espacio de cuidado integral donde la ciencia, la estética y la atención personalizada se unen para potenciar tu belleza natural con protocolos actualizados, seguros y resultados reales.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="rounded-2xl bg-brand-1 px-8 py-3 font-medium text-bg transition hover:opacity-90"
            >
              Agenda tu evaluación
            </a>

            <button
              type="button"
              onClick={goToFeatures}
              className="rounded-2xl border border-white/40 bg-white/20 px-8 py-3 font-medium text-white backdrop-blur transition hover:bg-white/30"
            >
              Ver tratamientos
            </button>
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {[
              "Diplomado dermoestetica",
              "Protocolos seguros",
              "Resultados naturales",
              "Productos certificados por ISP",
              "Atención personalizada",
            ].map((t) => (
              <span
                key={t}
                className="rounded-full border border-white/30 bg-white/20 px-4 py-1 text-xs text-white/90 backdrop-blur"
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-xs tracking-widest text-white/80">
        SCROLL
      </div>
    </section>
  );
}